import { gsap } from 'gsap';

export function initBlockCard01(parent) {
  if (!parent) return;

  const cards = parent.querySelectorAll('.block-card-01__card');
  cards.forEach((card, index) => {
    card.addEventListener('click', () => {
      card.classList.toggle('is-active');
    });

    if (card.classList.contains('no-entry-animation')) {
        return;
    }

    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initBlockCard01s() {
  const blocks = document.querySelectorAll('.block-card-01');
  blocks.forEach((block) => initBlockCard01(block));
}
